import styled from 'styled-components/macro';
import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PopoverClose = styled(PopoverPrimitive.Close)``;
